import {useConfig} from "../context/ConfigContext";

const buildAbsoluteUrl = (path) => {
    if(!path){
        return '/'
    }
    const { config } = useConfig();
    const base_url = config?.base_url || 'https://www.emmezeta.hr';

    if (!path.startsWith('/')) {
        path = '/'+path;
    }
    if (base_url) {
        return `${base_url}${path}`;
    }
    return path;
}

export const BuildAbsoluteUrl = buildAbsoluteUrl